// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.authentication__header {
    color: white;
    text-align: center;
  }
  
  .authentication {
    width: 90%;
    max-width: 25rem;
    margin: 7rem auto;
    text-align: center;
  }
  
  .authentication form {
    margin-bottom: 1rem;
  }

  .authentication__show-password {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    margin: -0.5rem 0 1rem;
    font-size: 0.85rem;
    text-align: left;
    cursor: pointer;
  }

  .authentication .button-group {
    display: flex;
    justify-content: center; /* Center aligns the buttons horizontally */
    padding: 10px; /* Adds padding around the buttons */
    gap: 10px; /* Space between the two buttons */
}`, "",{"version":3,"sources":["webpack://./src/user/pages/Auth.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,uBAAuB,EAAE,2CAA2C;IACpE,aAAa,EAAE,oCAAoC;IACnD,SAAS,EAAE,kCAAkC;AACjD","sourcesContent":[".authentication__header {\n    color: white;\n    text-align: center;\n  }\n  \n  .authentication {\n    width: 90%;\n    max-width: 25rem;\n    margin: 7rem auto;\n    text-align: center;\n  }\n  \n  .authentication form {\n    margin-bottom: 1rem;\n  }\n\n  .authentication__show-password {\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n    margin: -0.5rem 0 1rem;\n    font-size: 0.85rem;\n    text-align: left;\n    cursor: pointer;\n  }\n\n  .authentication .button-group {\n    display: flex;\n    justify-content: center; /* Center aligns the buttons horizontally */\n    padding: 10px; /* Adds padding around the buttons */\n    gap: 10px; /* Space between the two buttons */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
